import { NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";
import {FormsModule, ReactiveFormsModule}   from "@angular/forms";
import {FlexLayoutModule}                   from "@angular/flex-layout";
import {NgxDatatableModule}                 from "@swimlane/ngx-datatable";
import {provideNgxMask}                      from "ngx-mask";
import {BaseModule}                         from "../base-module/base.module";
import { CurrencyMaskModule }               from "ng2-currency-mask";
import { FuseWidgetModule }                 from "@fuse/components/widget/widget.module";
import { NgxChartsModule }                  from "@swimlane/ngx-charts";
import { NgChartsModule }                     from "ng2-charts";

/** Components */
import { CadastroBoletaComponent }from "./cadastro-boleta/cadastro-boleta.component";

import { ListaBoletaComponent } from "./lista-boleta/lista-boleta.component";
import { ListaHistoricoComponent }from "./lista-historico/lista-historico.component";
import { MovimentacaoRoutesModule } from "./movimentacao.routing";
import { VisualizaHistoricoComponent } from "./visualiza-historico/visualiza-historico.component";
import { ListaCustodiaComponent } from "./lista-custodia/lista-custodia.component";
import { CadastroCustodiaComponent } from "./cadastro-custodia/cadastro-custodia.component";
import { FiltrarBoletaComponent } from "./filtrar-boleta/filtrar-boleta.component";
import { CadastroAtivoComponent } from "./cadastro-ativo/cadastro-ativo.component";
import { AtualizaStatusBoletaComponent } from "./atualiza-status-boleta/atualiza-status-boleta.component";
import { FiltrarCustodiaComponent } from "./filtrar-custodia/filtrar-custodia.component";
import { ListaHistoricoCustodiaComponent } from "./lista-historico-custodia/lista-historico-custodia";

/** Services */
import { BoletaService } from "./services/boleta.service";
import { HistoricoMovimentacaoService } from "./services/historico-movimentacao.service";
import { ConfirmaBoletaComponent } from "./confirma-boleta/confirma-boleta.component";
import { CustodiaService} from "./services/custodia.service";
import { ImportacaoArquivoService } from "./services/importacao-arquivo.service";

import {registerLocaleData} from "@angular/common";
import br from "@angular/common/locales/br";
import { ExcluirCustodiaComponent } from "./excluir-custodia/excluir-custodia.component";
import { FiltroCustodiaConsolidadaComponent } from "./filtro-custodia-consolidada/filtro-custodia-consolidada.component";
import { ListaBoletaUnicaComponent } from "./lista-boleta-unica/lista-boleta-unica.component";
import { BoletaUnicaService } from "./services/boleta-unica.service";
import { CadastroBoletaUnicaComponent } from "./cadastro-boleta-unica/cadastro-boleta-unica.component";
import { StatusOrdemService } from "app/renda-variavel/services/status-ordem.service";
import { StatusMovimentacaoService } from "app/auxiliares/services/status-movimentacao.service";
import { ClienteService } from "app/clientes/services/cliente.service";
import { AcaoComercialService } from "app/acao-comercial/services/acao-comercial.service";
import { ParametroService } from "app/parametros/services/parametro.service";
import { AtivoService } from "app/auxiliares/services/ativo-service";
import { CarteiraService } from "app/clientes/services/carteira.service";
import { RendaVariavelModule } from "app/renda-variavel/renda-variavel.module";
import { AlteraValorBoletaComponent } from "./altera-valor-boleta/altera-valor-boleta.component";
import { ListaCustodiaRvSetorComponent } from "./lista-custodia-rv-setor/lista-custodia-rv-setor.component";
import { TipoConsorcioService } from "../consorcio/services/tipo-consorcio.service";
import { MatIconModule } from "@angular/material/icon";
import { MatCardModule } from "@angular/material/card";
import { MatInputModule } from "@angular/material/input";
import { MatCheckboxModule } from "@angular/material/checkbox";
import { MatButtonModule } from "@angular/material/button";
import { MatGridListModule } from "@angular/material/grid-list";
import { MatToolbarModule } from "@angular/material/toolbar";
import { MatProgressSpinnerModule } from "@angular/material/progress-spinner";
import { MatTooltipModule } from "@angular/material/tooltip";
import { MatSnackBarModule } from "@angular/material/snack-bar";
import { MatPaginatorModule } from "@angular/material/paginator";
import { MatListModule } from "@angular/material/list";
import { MatSelectModule } from "@angular/material/select";
import { MatOptionModule, MatRippleModule } from "@angular/material/core";
import { MatAutocompleteModule } from "@angular/material/autocomplete";
import { MatDatepickerModule } from "@angular/material/datepicker";
import { MatTabsModule } from "@angular/material/tabs";
import { MatRadioModule } from "@angular/material/radio";
import { MatMenuModule } from "@angular/material/menu";
import { MatChipsModule } from "@angular/material/chips";
import { MatExpansionModule } from "@angular/material/expansion";
import { MatFormFieldModule } from "@angular/material/form-field";
import { MatSortModule } from "@angular/material/sort";
import { MatTableModule } from "@angular/material/table";
import { MatSlideToggleModule } from "@angular/material/slide-toggle";
import { MatDividerModule } from "@angular/material/divider";
import { FileUploadModule } from "ng2-file-upload";

registerLocaleData(br, "pt-BR");

@NgModule({
    imports: [
        CommonModule,
        MovimentacaoRoutesModule,
        MatIconModule,
        MatCardModule,
        MatInputModule,
        MatCheckboxModule,
        MatButtonModule,
        MatGridListModule,
        MatToolbarModule,
        MatProgressSpinnerModule,
        MatTooltipModule,
        MatSnackBarModule,
        MatPaginatorModule,
        MatListModule,
        MatSelectModule,
        MatOptionModule,
        MatAutocompleteModule,
        MatDatepickerModule,
        MatTabsModule,
        MatRadioModule,
        MatMenuModule,
        MatChipsModule,
        MatExpansionModule,
        MatFormFieldModule,
        MatRippleModule,
        MatSortModule,
        MatTableModule,
        FormsModule,
        ReactiveFormsModule,
        FlexLayoutModule,
        NgxDatatableModule,
        BaseModule,
        CurrencyMaskModule,
        MatSlideToggleModule,
        MatDividerModule,
        FileUploadModule,
        FuseWidgetModule,
        NgxChartsModule,
        NgChartsModule,
        RendaVariavelModule,
    ],
    declarations: [
        ListaBoletaComponent,
        CadastroBoletaComponent,
        ListaHistoricoComponent,
        ConfirmaBoletaComponent,
        VisualizaHistoricoComponent,
        ListaCustodiaComponent,
        CadastroCustodiaComponent,
        FiltrarBoletaComponent,
        CadastroAtivoComponent,
        AtualizaStatusBoletaComponent,
        FiltrarCustodiaComponent,
        ExcluirCustodiaComponent,
        ListaHistoricoCustodiaComponent,
        FiltroCustodiaConsolidadaComponent,
        ListaBoletaUnicaComponent,
        CadastroBoletaUnicaComponent,
        AlteraValorBoletaComponent,
        ListaCustodiaRvSetorComponent,
    ],
    providers: [
        BoletaService,
        HistoricoMovimentacaoService,
        CustodiaService,
        ImportacaoArquivoService,
        BoletaUnicaService,
        StatusOrdemService,
        StatusMovimentacaoService,
        ClienteService,
        AcaoComercialService,
        ParametroService,
        AtivoService,
        CarteiraService,
        TipoConsorcioService,
        provideNgxMask()
    ],
    exports: [
        CommonModule,
        FiltrarBoletaComponent,
        CadastroAtivoComponent,
    ],
})
export class MovimentacaoModule {}
